import React, { useEffect, useRef } from 'react';
import { TextInput, TextInputProps } from '../TextInput';
import { SearchInputPrefix } from './SearchInputPrefix';
import { SearchInputSuffix } from './SearchInputSuffix';

export interface ISearchInputProps extends TextInputProps {
  placeholder?: string;
  value?: string;
  fullWidth?: boolean;
  error?: boolean;
  isSearching?: boolean;
  searchSuggestion?: string;
  onChange?: (v: any) => void;
  onKeyDown?: (v: any) => void;
  onClear?: () => void;
}

export const SearchInput: React.FC<ISearchInputProps> = ({
  placeholder = 'Enter 3 or more characters',
  searchSuggestion = 'Enter 3 or more characters',
  value,
  fullWidth,
  error,
  isSearching = false,
  onClear,
  onKeyDown,
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement>(document.createElement('input'));

  useEffect(() => {
    const changePlaceholder = () => {
      inputRef.current.placeholder = searchSuggestion;
      // inputRef.current.classList.add('custom-placeholder');
    };
    const defaultPlaceholder = () => {
      inputRef.current.placeholder = placeholder;
      // inputRef.current.classList.remove('custom-placeholder');
    };
    inputRef.current.addEventListener('focus', changePlaceholder);
    inputRef.current.addEventListener('blur', defaultPlaceholder);

    inputRef.current.classList.add('custom-placeholder');

    return () => {
      inputRef.current?.removeEventListener('focus', changePlaceholder);
      inputRef.current?.removeEventListener('blur', defaultPlaceholder);
    };
  }, [searchSuggestion]);

  const inputProps = rest.inputProps || {};
  inputProps['data-testid'] = `txt-${rest['data-testid'] || rest.id || ''}`;

  return (
    <TextInput
      id='search'
      value={value}
      sx={{
        'paddingLeft': '8px !important',
        '& .MuiOutlinedInput-input': {
          '&::placeholder': {
            color: 'rgba(51, 54, 61, 0.40) !important',
          },
        },
        '& .MuiButtonBase-root': {
          marginRight: '5px !important',
        },
        '& .MuiInputAdornment-root': {
          marginRight: '0px !important',
          marginLeft: '0px !important',
        },
        '& input': {
          paddingRight: '0 !important',
        },
        'backgroundColor': '#F8F8FC',
      }}
      {...rest}
      onKeyDown={onKeyDown}
      inputRef={inputRef}
      placeholder={placeholder}
      prefix={<SearchInputPrefix />}
      suffix={
        <SearchInputSuffix
          isSearching={!!value || isSearching}
          onClearClick={() => {
            if (value || isSearching) {
              onClear();
            }
          }}
        />
      }
    />
  );
};
